import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import App from './App.js';
import { AuthProvider } from './contexts/AuthContext.js';
import { CompanyProvider } from './contexts/CompanyContext.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode> removed strict mode to see if it will stop the re-render issue 14 may 2025
    <BrowserRouter>
      <AuthProvider>
        <CompanyProvider>
          <App />
        </CompanyProvider>
      </AuthProvider>
    </BrowserRouter>
  //</React.StrictMode>
);